<template>
  <div>
    <Molded class="type-payment-list-header" :paddingTop="16" :paddingRight="20" :paddingBottom="16" :paddingLeft="20">
      <div class="type-payment-list-toolbar">
        <Button _key="btnTypePaymentCreate" title="Tipo de Pagamento" classIcon="fas fa-plus-circle" type="primary"
          size="small" :clicked="create" />
      </div>

      <div class="type-payment-list-filter">
        <div class="type-payment-list-filter-search">
          <Search />
        </div>
        <TableTotalPerPage :totalRecords="totalRecords" />
      </div>
    </Molded>

    <div class="type-payment-list-card">
      <Loading v-if="loading" type="line" :center="false" class="type-payment-list-loading" />

      <section class="type-payment-list-topbar">
        <div class="type-payment-list-topbar-left">
          <b-form-checkbox v-model="selectAll" @change="onSelectAll" />
          <span class="type-payment-list-select-all">Selecionar tudo</span>
        </div>
        <div class="type-payment-list-topbar-right">
          <TotalRecordsBadge :total="totalRecords" />
        </div>
      </section>

      <div v-if="!loading && typePayments.length === 0" class="type-payment-list-empty">
        Nenhum tipo de pagamento encontrado
      </div>

      <TypePaymentRow v-for="typePayment in typePayments" :key="typePayment.id" :typePayment="typePayment"
        :selected="isSelected(typePayment)" @edit="edit" @select="toggleSelect" />

      <Pagination :totalRecords="totalRecords" />
    </div>

    <BottomActionsBar :selected="selectedIds" @close="cleanSelected">
      <ActionsSelected :selected="selectedIds" :actions="actions" />
    </BottomActionsBar>

    <Modal title="Tipo de Pagamento" :width="500" :height="250" v-show="showModal('typePaymentCreateUpdate')">
      <TypePaymentCreateUpdate />
    </Modal>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import Modal from "@/ui/forms/Modal";

import BottomActionsBar from "@/ui/layout/BottomActionsBar";
import Molded from "@/ui/layout/Molded";
import TotalRecordsBadge from "@/ui/layout/TotalRecordsBadge.vue";

import ActionsSelected from "@/ui/shared/actions/ActionsSelected.vue";
import Loading from "@/ui/shared/Loading.vue";
import Pagination from "@/ui/shared/Pagination.vue";
import Search from "@/ui/shared/Search.vue";
import TableTotalPerPage from "@/ui/shared/TableTotalPerPage.vue";

import TypePaymentRow from "./TypePaymentRow.vue";
import TypePaymentCreateUpdate from "./TypePaymentCreateUpdate.vue";

import TypePaymentService from "../../services/typePayment.service";

import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  name: "TypePaymentList",
  components: {
    Button,
    Modal,
    BottomActionsBar,
    Molded,
    TotalRecordsBadge,
    ActionsSelected,
    Loading,
    Pagination,
    Search,
    TableTotalPerPage,
    TypePaymentRow,
    TypePaymentCreateUpdate,
  },
  data() {
    return {
      typePayments: [],
      totalRecords: 0,
      selectedIds: [],
      selectAll: false,
      currentPage: 1,
      loading: true,
      actions: [
        { type: "delete", title: "Remover", description: "Remover", url: TypePaymentService.urlDelete, method: "post" },
      ],
    };
  },
  mounted() {
    this.list();
  },
  beforeDestroy() {
    this.updateSearch({ content: "", filter: { content: "Contém", id: "contains" } });
  },
  computed: {
    ...mapState("generic", ["paginations", "search", "executedSearch", "clearedSearch"]),
    ...mapGetters("generic", ["showModal", "event"]),
    totalPerPage() {
      return this.paginations.totalPerPage || 10;
    },
  },
  methods: {
    ...mapMutations("generic", ["openModal", "addEvent", "removeLoading", "updateSearch"]),
    async list() {
      this.loading = true;
      try {
        const response = await TypePaymentService.getAll({
          search: this.search.content,
          filter: this.search.filter.id || "contains",
          currentPage: this.currentPage,
          totalPerPage: this.totalPerPage,
        });
        this.typePayments = response.content.items || [];
        this.totalRecords = response.content.totalRecords || 0;
        this.selectAll = false;
      } finally {
        this.loading = false;
      }
    },
    create() {
      this.openModal("typePaymentCreateUpdate");
      this.addEvent({ name: "typePaymentCreate" });
      this.removeLoading(["btnTypePaymentCreate"]);
    },
    edit(typePayment) {
      this.openModal("typePaymentCreateUpdate");
      this.addEvent({ name: "typePaymentUpdate", data: typePayment });
    },
    isSelected(typePayment) {
      return this.selectedIds.includes(typePayment.id);
    },
    toggleSelect(typePayment) {
      if (this.isSelected(typePayment)) {
        this.selectedIds = this.selectedIds.filter((id) => id != typePayment.id);
        return;
      }
      this.selectedIds = [...this.selectedIds, typePayment.id];
    },
    onSelectAll(checked) {
      if (checked) {
        this.selectedIds = this.typePayments.map((typePayment) => typePayment.id);
        return;
      }
      this.selectedIds = [];
    },
    cleanSelected() {
      this.selectedIds = [];
      this.selectAll = false;
    },
  },
  watch: {
    executedSearch: function () {
      this.currentPage = 1;
      this.list();
      this.removeLoading(["btnSearch"]);
    },
    clearedSearch: function () {
      this.currentPage = 1;
      this.list();
      this.removeLoading(["btnClean"]);
    },
    event: {
      handler(event) {
        if (event.name == "typePaymentSaved") this.list();
        if (event.name == "deselectAll") this.cleanSelected();
        if (event.name == "page-click") {
          this.currentPage = event.data;
          this.list();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.type-payment-list-header {
  margin-bottom: 16px;
}

.type-payment-list-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.type-payment-list-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin: 16px 0;
}

.type-payment-list-filter > :last-child {
  flex-shrink: 0;
}

.type-payment-list-filter-search {
  flex: 1 1 320px;
  min-width: 0;
}

.type-payment-list-filter-search >>> .margin {
  padding-top: 0;
}

.type-payment-list-filter-search >>> .div-button {
  padding-top: 0;
}

.type-payment-list-card {
  border: 1px solid var(--border-color);
  background: var(--bg-base);
  border-radius: 10px;
  padding: 16px;
  box-shadow: var(--shadow-sm);
}

.type-payment-list-loading {
  margin-bottom: 12px;
}

.type-payment-list-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 0 8px;
  border-bottom: 1px solid var(--border-subtle);
}

.type-payment-list-topbar-left {
  display: flex;
  align-items: center;
}

.type-payment-list-topbar-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.type-payment-list-select-all {
  color: var(--text-primary);
  font-size: 14px;
}

.type-payment-list-empty {
  padding: 24px;
  text-align: center;
  color: var(--text-muted);
  font-size: 14px;
}

@media (max-width: 768px) {
  .type-payment-list-card {
    padding: 12px;
  }
}
</style>
